// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb36a99b","239":"e82022de","455":"9a169ef8"}[chunkId] + ".chunk.js";
};